module.exports = __webpack_public_path__ + "static/img/004.b52d4bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/004.jpg
// module id = gYN4
// module chunks = 11